export default __webpack_public_path__ + "static/media/282.6de3f431.jpg";